import { SITE } from "@/content/site";

export const BOOKING_URL = SITE.bookingPath;
export const NAV_LINKS = SITE.navigation;
export const PRIVATE_EXPERIENCES_EMAIL = SITE.privateExperiencesEmail;

export const scrollToSection = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { duration: 1.6 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const goToLink = (link, { pathname, navigate }) => {
  if (link.href.startsWith("/")) {
    navigate(link.href);
    return;
  }
  if (pathname !== "/") {
    navigate("/");
    setTimeout(() => scrollToSection(link.href), 700);
  } else {
    scrollToSection(link.href);
  }
};
